// import Utils from "../components.utils";
import * as moment from 'moment';
import 'moment-timezone';
import {mapGetters} from "vuex"
export default{
methods:{    
        getDateAndTimeInConfiguredFormat(dateTime, showOnlydate=false){
            let dateAndTimeFormat =  this.getStartUpdata().datetime_format && this.getStartUpdata().datetime_format.format ? this.getStartUpdata().datetime_format.format : "DD MMM YYYY hh:mm A";
            let convertedToLocalTimeZone = this.convertToLocalTimeZone(dateTime);

            
            //*********below calculation is to check is date is today's date or yesterday's date***************
            let hhOrhhHourFormat = dateAndTimeFormat.includes("h:")?' h':dateAndTimeFormat.includes('HH')?' HH' :' hh'; //intesionally given one space before h/H for split purpose; 
            let dateFormat = dateAndTimeFormat.split(hhOrhhHourFormat)[0].trim();
            let timeFormat = dateAndTimeFormat.split(dateFormat)[1].trim();
            let getOnlyDate = convertedToLocalTimeZone.format(dateFormat);
            let getOnlyTime = convertedToLocalTimeZone.format(timeFormat);
 
            let todaysDate = this.convertToLocalTimeZone(moment.utc()).format(dateAndTimeFormat.split(hhOrhhHourFormat)[0].trim());
            let calculatedDateTimeValue = "-";
            let yesterdaysDate = this.convertToLocalTimeZone(moment.utc()).subtract(1, 'days').toString();
            let yesterdayDateEvent = new Date(yesterdaysDate);
            let yesterdayDate = JSON.stringify(yesterdayDateEvent).slice(1, 11);
            let yesterdayDateFormat = yesterdayDate.split("-").reverse().join("/");
            //************************************************************* */
            if(showOnlydate){
                if (getOnlyDate == todaysDate) {
                    calculatedDateTimeValue = getOnlyTime;
                } else if (getOnlyDate == yesterdayDateFormat) {
                    calculatedDateTimeValue = "yesterday";
                } else {
                    // if(showOnlydate){
                        // calculatedDateTimeValue = getOnlyDate;
                        calculatedDateTimeValue = this.getOnlyDateInConfiguredFormat(dateTime);
                    // }else{
                    //     calculatedDateTimeValue = convertedToLocalTimeZone.format(dateAndTimeFormat);
                    }
            }else{
                calculatedDateTimeValue = convertedToLocalTimeZone.format(dateAndTimeFormat);
            }    
            
            return calculatedDateTimeValue;
        },

        getOnlyDateInConfiguredFormat(dateTime){
            let dateFormat = this.getStartUpdata().date_format && this.getStartUpdata().date_format.format ? this.getStartUpdata().date_format.format:"DD MMMM YYYY";
            // let timeZone = this.getStartUpdata().time_zone;
            let convertedToLocalTimeZone = this.convertToLocalTimeZone(dateTime);
            return convertedToLocalTimeZone.format(dateFormat);
        },

        
        //this function is given  to check is date it today or yesterday, just wanted true or false so kept same calculation as separate function
        checkIsTodayoryesterdayDate(dateTime){
            let dateAndTimeFormat =  this.getStartUpdata().datetime_format && this.getStartUpdata().datetime_format.format ? this.getStartUpdata().datetime_format.format : "DD MMM YYYY hh:mm A";
            let convertedToLocalTimeZone = this.convertToLocalTimeZone(dateTime);

            
            //*********below calculation is to check is date is today's date or yesterday's date***************
            let hhOrhhHourFormat = dateAndTimeFormat.includes("h:")?' h':dateAndTimeFormat.includes('HH')?' HH' :' hh'; //intesionally given one space before h/H for split purpose; 
            let dateFormat = dateAndTimeFormat.split(hhOrhhHourFormat)[0].trim();
            // let timeFormat = dateAndTimeFormat.split(dateFormat)[1].trim();
            let getOnlyDate = convertedToLocalTimeZone.format(dateFormat);
            // let getOnlyTime = convertedToLocalTimeZone.format(timeFormat);
 
            let todaysDate = this.convertToLocalTimeZone(moment.utc()).format(dateAndTimeFormat.split(hhOrhhHourFormat)[0].trim());
            let isTodayOrYesterday = false;
            let yesterdaysDate = this.convertToLocalTimeZone(moment.utc()).subtract(1, 'days').toString();
            let yesterdayDateEvent = new Date(yesterdaysDate);
            let yesterdayDate = JSON.stringify(yesterdayDateEvent).slice(1, 11);
            let yesterdayDateFormat = yesterdayDate.split("-").reverse().join("/");
            //************************************************************* */

            if (getOnlyDate == todaysDate) {
                isTodayOrYesterday = true;
            } else if (getOnlyDate == yesterdayDateFormat) {
                isTodayOrYesterday = true;
            }
            return isTodayOrYesterday;
        },

        convertToLocalTimeZone(dateTime){
            // let curretTimeZone = moment.tz.guess(); //timeZone of curretnPalce 
            let originTimeZone = this.getStartUpdata().system_time_zone? this.getStartUpdata().system_time_zone : 'Asia/Kolkata';
            let applicationTimeZone = 'user_time_zone' in this.getStartUpdata() && this.getStartUpdata().user_time_zone ? this.getStartUpdata().user_time_zone : this.getStartUpdata().application_time_zone ? this.getStartUpdata().application_time_zone : 'Asia/Kolkata';           
            // let dateAndTimeFormat =  this.getStartUpdata().datetime_format && this.getStartUpdata().datetime_format.format ? this.getStartUpdata().datetime_format.format : "DD MMM YYYY hh:mm A";            
            let getDateTimeWithCureentTimeZone = moment.tz(dateTime, originTimeZone).clone().tz(applicationTimeZone);
            
            return getDateTimeWithCureentTimeZone;
        },

        getStartUpdata(){
            if(typeof this.getStartUpDataFromInCache == "function"){
                return this.getStartUpDataFromInCache()
            }else{
                return this.getStartUpDataFromInCache;
            }
        },

        isRTL(){
            return document.documentElement.dir === 'rtl';
        },

        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
    },

    // computed:{
    //     ...mapGetters("startUpData",["getStartUpDataFromInCache"])
    // }       
}    